import { forwardRef, lazy } from "react"

import { useTranslation } from "react-i18next"

import { ANIMATION_LINKS } from "@/constants"
import { HappyOwlSvg } from "@/svgs/HappyOwlSvg"

import "../styles.scss"

const LazyAnimationPlayer = lazy(() =>
    import("@/shared/lib/components/AnimationPlayer").then(m => ({ default: m.AnimationPlayer }))
)

type Props = {}

export const SimulabEndConversationLoader = forwardRef<HTMLDivElement, Props>((props, ref) => {
    const { t } = useTranslation()

    return (
        <div className="simulab-feedback-loader" ref={ref} data-testid="simualab-feedback-loader">
            <div className="simulab-feedback-loader__animation-box">
                <LazyAnimationPlayer
                    src={ANIMATION_LINKS.CONFETTI}
                    autoplay
                    loop
                    className="simulab-feedback-loader__background"
                />
                <div className="simulab-feedback-loader__icon">
                    <HappyOwlSvg />
                    <div className="simulab-feedback-loader__text">
                        <span>{t("You did it!")}</span>
                    </div>
                </div>
            </div>
            <div className="simulab-feedback-loader__wrapper">
                <div className="position-relative ml-3">
                    <LazyAnimationPlayer
                        src={ANIMATION_LINKS.SPINNER}
                        autoplay
                        loop
                        className="simulab-feedback-loader__spinner"
                    />
                    <p className="mb-0">{t("Generating feedback summary")}...</p>
                    <p className="color-gray fs-14 m-0 font-italic">{t("This may take up to 30 seconds")}</p>
                </div>
            </div>
        </div>
    )
})
